module.exports = __webpack_public_path__ + "static/media/IXe.706f998d.jpg";